export default "__VITE_ASSET__DTvx_YTz__"